<template>
  <div class="login-wrapper cool-border">
    <el-form
      :model="signUpData"
      class="login-info "
      label-width="140px"
      ref="signUpForm"
    >
      <div class="login-info-title">
        <div>
          Sign up
        </div>
      </div>
      <el-form-item
        label="first name"
        :prop="'first_name'"
        :rules="stringRule('first name')"
      >
        <el-input
          v-model="signUpData.first_name"
          placeholder="please input your first name"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="last name"
        :prop="'last_name'"
        :rules="stringRule('last name')"
      >
        <el-input
          v-model="signUpData.last_name"
          placeholder="please input your last name"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="display name"
        :prop="'display_name'"
        :rules="stringRule('display name')"
      >
        <el-input
          v-model="signUpData.display_name"
          placeholder="please input your display name"
        ></el-input>
      </el-form-item>
      <el-form-item label="phone" :prop="'phone'">
        <el-input
          v-model="signUpData.phone"
          placeholder="please input your phone"
        ></el-input>
      </el-form-item>
      <el-form-item label="company" :prop="'company_name'">
        <el-input
          v-model="signUpData.company_name"
          placeholder="please input your company"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="password"
        :prop="'password'"
        :rules="passwordRule('password')"
      >
        <el-input
          v-model="signUpData.password"
          placeholder="please input your password"
          show-password
        ></el-input>
      </el-form-item>
      <el-form-item
        label="repeat password"
        :prop="'repeat_password'"
        :rules="repeatPasswordRule('password', signUpData.password)"
      >
        <el-input
          v-model="signUpData.repeat_password"
          placeholder="please repeat your password"
          show-password
        ></el-input>
      </el-form-item>
      <div class="login-info-option">
        <el-button
          class="login-info-option-button"
          type="primary"
          @click="submit()"
          >Submit</el-button
        >
      </div>
    </el-form>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import MixFormRule from "@/components/mixins/formRule";
export default {
  name: "resetPassword",
  mixins: [MixFormRule],
  data() {
    return {
      signUpData: {
        token: "",
        email: "",
        password: "",
        repeat_password: "",
        first_name: "",
        last_name: "",
        display_name: "",
        phone: "",
        company_name: "",
      },
    };
  },
  async mounted() {
    await store.dispatch("user/logout");
  },
  methods: {
    async submit() {
      try {
        let res = await this.$refs.signUpForm.validate();
        if (res) {
          this.signUpData.token = this.getUrlQuery("new_user_token");
          this.signUpData.email = this.getUrlQuery("email");
          await store.dispatch("userManagement/signUp", this.signUpData);
          Vue.prototype.$notify.success({
            title: "Send email",
            message: "sign up success",
            position: "bottom-right",
            offset: 20,
            duration: 3000,
          });
          setTimeout(() => {
            this.$router.push("/");
          }, 3000);
        }
      } catch (e) {
        Vue.prototype.$notify.error({
          title: "error",
          message: e.response.data.message,
          position: "bottom-right",
          offset: 20,
          duration: 3000,
        });
        console.log(e);
      }
    },
    getUrlQuery(key) {
      return this.$route.query[key];
    },
  },
};
</script>
<style lang="sass" scoped>
@keyframes animatedgradient
  0%
    background-position: 0% 50%
  50%
    background-position: 100% 50%
  100%
    background-position: 0% 50%
.login-theme
  &-font
    color: $color-blue
    font-family: "Acumin Pro"

.login-wrapper
  .login-info
    width: 500px
    padding: 16px
    z-index: 1
    background: white
    &-switch
      font-size: 14px
      text-align: right
      cursor: pointer
    &-title
      margin: 4px 0px 24px
      display: flex
      justify-content: center
      color: $color-blue
      font-size: 24px
      font-family: "Acumin Pro"
    &-option
      margin-top: 12px
      display: flex
      justify-content: flex-end
      &-button
        width:100%
        background-color: $color-blue
        color: white
        margin-top: 30px
    ::v-deep .el-form-item__label
      text-align: left
  h1
    color: $color-blue
    text-align: center
  .btn
    position: relative
    display: block
    border: none
    cursor: pointer
    outline: none
    left: 50%
    transform: translateX(-50%)
  .login-btn
    font-size: 18px
    font-weight: 400
    color: $color-white
    background-color: $color-blue
    border-radius: 30px
    padding: 10px
    text-align: center
    width: 150px
    text-decoration: none
</style>
